export const TOGGLE_DELETE_MODAL = 'toggleDeleteModal' as const;
export const TOGGLE_EDIT_MODAL = 'toggleEditModal' as const;
export const TOGGLE_ADD_MODAL = 'toggleAddModal' as const;
